import React from 'react';
import { AuthCheckAdmin } from '../../Utils/AuthCheck/AdminCheck.auth';
import { useQuery } from '@tanstack/react-query';
import { httpGetPurchaseHistory } from '../../Hooks/user/user.get.hooks';
import PropTypes from 'prop-types';
import UserPurchasesInner from './UserPurchasesInner.component';

const UserPurchases = ({ userId }) => {
  if (!userId) {
    return <p>No user ID provided.</p>;
  }
  const {
    data: purchaseHistory,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['purchaseHistory'],
    queryFn: () => httpGetPurchaseHistory(userId),
    enabled: !!userId,
    retry: 5,
  });
  if (isLoading) return <p>Loading...</p>;
  if (isError) return <p>Error loading purchase history</p>;
  // console.log('Purchase History:', purchaseHistory);
  return (
    <>
      <AuthCheckAdmin>
        <h3 className="m1B">Purchase History</h3>
        <UserPurchasesInner purchaseHistory={purchaseHistory} />
      </AuthCheckAdmin>
    </>
  );
};
UserPurchases.propTypes = {
  userId: PropTypes.string,
};

export default UserPurchases;
